import { useCallback, useEffect, useState } from 'preact/compat';
import { calculateStandardPrice, calculateTotalPrice } from '@genericBookings/calculatePrice';
function useCheckoutPrice(activities) {
    const selectedActivities = activities.filter((activity) => activity.activeSession !== undefined);
    const [standardPrice, setStandardPrice] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const calculateActivitiesStandardPrice = useCallback(() => {
        const standardPriceSum = calculateStandardPrice(selectedActivities);
        setStandardPrice(standardPriceSum);
    }, [selectedActivities]);
    const calculateActivitiesTotalPrice = useCallback(() => {
        const totalPriceSum = calculateTotalPrice(selectedActivities);
        setTotalPrice(totalPriceSum);
    }, [selectedActivities]);
    useEffect(calculateActivitiesStandardPrice, [selectedActivities, calculateActivitiesStandardPrice]);
    useEffect(calculateActivitiesTotalPrice, [selectedActivities, calculateActivitiesTotalPrice]);
    return {
        standardPrice,
        totalPrice,
    };
}
export default useCheckoutPrice;
